import React from 'react';
import { KompisPriceModule } from '@inter-ikea-kompis/react-components';
import { IShoppingProduct } from '@inter-ikea-kompis/types/lib';
import { TypographyProps } from 'styled-system';
import { PriceModuleLayoutTypeEnum } from '@inter-ikea-kompis/component-price-module';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { useServiceSettings } from 'contexts/serviceSettings';

export type Props = TypographyProps &
  React.ComponentProps<typeof KompisPriceModule> & {
    shoppingProducts: IShoppingProduct[];
    isFromPrice?: boolean;
    isCombinedProduct?: boolean;
    layout?: PriceModuleLayoutTypeEnum;
    children?: React.ReactNode;
    productName?: string;
    showPriceUnit?: boolean;
  };

const PriceModule = ({ children, ...props }: Props) => {
  const { translations, dexfSettings } = useServiceSettings();
  const singleProduct = props.shoppingProducts.length === 1;

  return (
    <KompisPriceModule
      showLowestPreviousSalesPrice={singleProduct}
      showOfferMessage={true}
      data-testid="price-module"
      translations={translations.kompis}
      settings={dexfSettings}
      theme={SkapaTheme}
      {...props}
    >
      {children}
    </KompisPriceModule>
  );
};

export default PriceModule;
